import { FC } from 'react'

import * as S from './styled'
import { GiftIcon, CalendarIcon, ArcPlusIcon } from '../../icons'

const Dates: FC = () => (
  <S.Container>
    <S.Wrapper>
      <S.Content>
        <S.Title>
          <span>02</span> Datas
        </S.Title>

        <S.InfoTable>
          Verifique abaixo as datas aplicáveis ao Programa de Fidelidade
          conforme o critério para obter os benefícios:
        </S.InfoTable>

        <S.TableWrapper>
          <S.Table>
            <thead>
              <tr>
                <td width="40%">
                  <S.TableInner>
                    <GiftIcon />
                    <S.TableLabel>Benefício</S.TableLabel>
                  </S.TableInner>
                </td>
                <td>
                  <S.TableInner>
                    <CalendarIcon />
                    Data de Início
                  </S.TableInner>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <S.TableLabel>Acúmulo de pontos</S.TableLabel>
                </td>
                <td>
                  <S.TableInner>
                    <S.TableBG>
                      Lojas LEROY MERLIN (exceto MG):
                      <br />
                      <strong>31/07/2019</strong>
                    </S.TableBG>
                    <S.TableBG>
                      Lojas de Minas Gerais (Estado)
                      <br />
                      <strong>20/05/2019</strong>
                    </S.TableBG>
                  </S.TableInner>
                </td>
              </tr>
              <tr>
                <td>
                  <S.TableLabel>Pontuação e Vale Cashback</S.TableLabel>
                </td>
                <td>
                  Site, app e televendas
                  <br />
                  <strong>05/02/2020</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <S.TableLabel>
                    Benefícios exclusivos para profissionais <br />
                    de construção civil
                  </S.TableLabel>
                </td>
                <td>
                  <strong>06/04/2020</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <S.TableLabel>Executor/PRO com cashback</S.TableLabel>
                </td>
                <td>
                  Cashback pelo valor mensal gasto
                  <br />
                  <strong>01/04/2023</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <ArcPlusIcon />
                </td>
                <td>
                  Algumas lojas
                  <br />
                  <strong>04/07/2024</strong>
                </td>
              </tr>
            </tbody>
          </S.Table>
        </S.TableWrapper>
      </S.Content>
    </S.Wrapper>
  </S.Container>
)

export default Dates
